export const onUseQueries = <T extends string, K>(queries: Record<T, K | null>): string => {
    let _queries = {}

    for (const key in queries) {
        if (queries[key]) {
            _queries = { ..._queries, [key]: queries[key] }
        }
    }

    if (!Object.keys(_queries).length) {
        return ''
    }

    return `?${new URLSearchParams(_queries).toString()}`
}
